/* Florence Speed 1.0 - MIT. No telemetry, libraries or navigation interception. */
(() => {
  'use strict';
  if (window.__fpSpeed || window.Shopify?.designMode) return;
  window.__fpSpeed = true;
  const warmed = new Set();
  const connection = navigator.connection;
  const slow = () => connection?.saveData || /(^|-)2g$|^3g$/.test(connection?.effectiveType || '');
  const nativeRules = () => [...document.querySelectorAll('script[type="speculationrules"]')].some(s => {
    try {
      const rules = JSON.parse(s.textContent);
      return Boolean(rules.prefetch?.length || rules.prerender?.length);
    } catch { return false; }
  });
  let ready = document.readyState === 'complete';
  window.addEventListener('load', () => { ready = true; }, { once: true });
  let timer;
  let pending;
  function eligible(target) {
    const a = target?.closest?.('a[href]');
    if (!a || a.hasAttribute('download') || (a.target && a.target !== '_self') ||
        a.closest('[data-no-prefetch], [data-fp-speed-ignore]') || /nofollow|external/.test(a.rel)) return null;
    let url;
    try { url = new URL(a.href, location.href); } catch { return null; }
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || url.search || url.hash ||
        url.username || url.password || url.pathname === location.pathname) return null;
    // Only public, read-only catalogue pages; no account, cart, checkout or custom app routes.
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products\/[^/]+|collections\/[^/]+(?:\/products\/[^/]+)?)\/?$/i.test(url.pathname)) return null;
    return url.href;
  }
  function warm(url) {
    if (!url || !ready || slow() || document.visibilityState !== 'visible' || warmed.size >= 2 ||
        warmed.has(url) || nativeRules()) return;
    if ([...document.querySelectorAll('link[rel="prefetch"],link[rel="prerender"]')].some(l => l.href === url)) return;
    const link = document.createElement('link');
    if (!link.relList?.supports?.('prefetch')) return;
    warmed.add(url);
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    link.dataset.fpSpeed = 'prefetch';
    document.head.appendChild(link);
  }
  function queue(event) {
    if (event.type === 'pointerover' && event.pointerType !== 'mouse') return;
    if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
    const url = eligible(event.target);
    if (url === pending) return;
    clearTimeout(timer);
    pending = url;
    if (url) timer = setTimeout(() => { pending = null; warm(url); }, 120);
  }
  document.addEventListener('pointerover', queue, { passive: true });
  document.addEventListener('focusin', queue, { passive: true });
  document.addEventListener('pointerout', event => {
    if (pending && eligible(event.relatedTarget) !== pending) {
      clearTimeout(timer); pending = null;
    }
  }, { passive: true });
  document.addEventListener('focusout', () => { clearTimeout(timer); pending = null; }, { passive: true });
  document.addEventListener('touchstart', event => {
    if (event.touches.length === 1) warm(eligible(event.target));
  }, { passive: true });
})();
